import React, { useState } from 'react';
import './Modal.css';

const TramiteDeleteModal = ({ isOpen, tramite, onClose, onConfirm }) => {
  const [deleting, setDeleting] = useState(false);

  const handleConfirm = async () => {
    setDeleting(true);
    try {
      await onConfirm();
    } finally {
      setDeleting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={() => !deleting && onClose()}>
      <div className="modal-content modal-small" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>🗑️ Eliminar Trámite</h2>
        </div>

        <div className="modal-body">
          <p>¿Estás seguro de que deseas eliminar este trámite de forma permanente?</p>
          {tramite && (
            <div className="cupl-preview" style={{ background: 'var(--secondary-soft, #f8fafc)', padding: '15px', borderRadius: '8px', margin: '15px 0', border: '1px solid var(--card-border, #e2e8f0)' }}>
              <div className="preview-item" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                <span className="label" style={{ fontWeight: 'bold', color: 'var(--text-secondary, #64748b)' }}>ID:</span>
                <span className="value" style={{ fontWeight: 'bold' }}>#{tramite.id}</span>
              </div>
              <div className="preview-item" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                <span className="label" style={{ fontWeight: 'bold', color: 'var(--text-secondary, #64748b)' }}>Tipo:</span>
                <span className="value">{tramite.tramite_type_name}</span>
              </div>
              <div className="preview-item" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                <span className="label" style={{ fontWeight: 'bold', color: 'var(--text-secondary, #64748b)' }}>Tránsito:</span>
                <span className="value">{tramite.transito_name}</span>
              </div>
              <div className="preview-item" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                <span className="label" style={{ fontWeight: 'bold', color: 'var(--text-secondary, #64748b)' }}>Propietario:</span>
                <span className="value">{tramite.datos_adicionales?.propietario || 'N/A'}</span>
              </div>
              {tramite.datos_adicionales?.placa_referencia && (
                <div className="preview-item" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                  <span className="label" style={{ fontWeight: 'bold', color: 'var(--text-secondary, #64748b)' }}>Placa Ref:</span>
                  <span className="value" style={{ background: '#fef3c7', padding: '2px 8px', borderRadius: '4px', fontSize: '12px', fontWeight: 'bold', color: '#b45309' }}>
                    {tramite.datos_adicionales.placa_referencia}
                  </span>
                </div>
              )}
            </div>
          )}
          <p className="warning-text" style={{ color: '#ef4444', fontWeight: '600', fontSize: '13px', margin: '10px 0 0 0' }}>
            ⚠️ Esta acción es irreversible: se liberará la placa asignada y se borrarán todos los archivos físicos asociados del servidor.
          </p>
        </div>

        <div className="modal-actions" style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' }}>
          <button
            type="button"
            className="btn-secondary"
            onClick={onClose}
            disabled={deleting}
            style={{ padding: '10px 20px', borderRadius: '8px', cursor: 'pointer', fontWeight: '600' }}
          >
            Cancelar
          </button>
          <button
            type="button"
            className="btn-primary"
            onClick={handleConfirm}
            disabled={deleting}
            style={{ padding: '10px 20px', borderRadius: '8px', cursor: 'pointer', backgroundColor: '#ef4444', borderColor: '#ef4444', color: 'white', fontWeight: '600' }}
          >
            {deleting ? '⏳ Eliminando...' : '🗑️ Eliminar'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TramiteDeleteModal;
